<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>

        <div class="vx-card__title mb-6">
          <h2 class="text-center">IDENTIFIQUE SUA LOJA</h2>
        </div>

        <img src="@/assets/images/pages/rocket.png" alt="coming-soon" class="mx-auto mb-2" width="150">

       <!--  <div class="count-down text-center">
          <countdown :time="new Date('03/09/2021 00:00:00').getTime() - new Date().getTime()">

            <template slot-scope="props">

              <div class="single-counter">
                <span class="timer">{{ props.days }}</span>
                <span>Days</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.hours }}</span>
                <span>Hours</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.minutes }}</span>
                <span>Minutes</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.seconds }}</span>
                <span>Seconds</span>
              </div>

            </template>
          </countdown>
        </div> -->

        <!-- <vs-divider position="center">Subscribe</vs-divider> -->

        <div class="subscription text-center">
          <!-- <p>Coloque o nome da sua loja após <strong>{{baseUrl}}</strong> na URL do site</p>
          <br/>
          <p>Por exemplo: {{baseUrl}}<strong>nome-da-sua-loja</strong>/login</p> -->
          <vs-input 
            type="text" 
            label-placeholder="Nome da sua loja"
            description-text="Tudo minúsculo e separado por hífen. Exemplo: nome-da-sua-loja"
            v-model="storeName" 
            class="w-full mb-4"
            style="text-align: center;"
            @keydown.enter="redirectToStore"
          />
          <vs-button
            class="w-full"
            :disabled="!storeName.length"
            @click="redirectToStore"
          >
            Acessar {{ appTitle }}
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import VueCountdown from '@chenfengyuan/vue-countdown'

import { getBaseUrl } from '@/utils'

export default {
  data() {
    return {
      storeName: ''
    }
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_APP_TITLE;
    },
    baseUrl() {
      return getBaseUrl()
    }
  },
  methods: {
    redirectToStore() {
      if (this.storeName === '') {
        return;
      }
      const url = `${this.baseUrl}${this.storeName}/login`
      window.location.href = url
    }
  },
  components: {
    'countdown': VueCountdown
  }
}

</script>

